<template>
  <v-card class="card--shadow">
    <v-card-title class="purple accent-4">
      <div class="subtitle-1 white--text">Volunteer Form</div>
    </v-card-title>
    <v-card-text class="pt-4">
      <form-require-noti />
      <v-row>
        <v-col cols="12" lg="4" sm="12">
          <label>Name <require-sign /></label>
          <v-text-field
            v-model.trim="volunteer.name"
            :error-messages="handleFieldErrors($v.volunteer.name)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="12">
          <label>Phone 1 <require-sign /></label>
          <v-text-field
            v-model.trim="volunteer.phone"
            :error-messages="handleFieldErrors($v.volunteer.phone)"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="12">
          <label>Phone 2</label>
          <v-text-field
            v-model.trim="volunteer.phone1"
            :error-messages="handleFieldErrors($v.volunteer.phone2)"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" lg="4">
          <label>Address <require-sign /></label>
          <v-text-field
            v-model.trim="volunteer.address"
            :error-messages="handleFieldErrors($v.volunteer.address)"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" lg="2">
          <label>Age <require-sign /></label>
          <v-text-field
            v-model.trim="volunteer.age"
            :error-messages="handleFieldErrors($v.volunteer.age)"
            type="number"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="3"
          v-show="admin.township.both_mdr_picts == 2"
        >
          <label>Both MDR and PICTS <require-sign /></label>
          <v-select
            :items="[
              { id: '1', name: `No` },
              { id: '2', name: `Yes` },
            ]"
            v-model="volunteer.both_mdr_picts"
            item-text="name"
            item-value="id"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col sm="12" lg="3">
          <label>Joining Date</label>
          <date-picker
            @clearDate="volunteer.joining_date = null"
            :date="volunteer.joining_date"
            v-model="volunteer.joining_date"
          />
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" lg="4" sm="12">
          <label>NRC No</label>
          <v-text-field
            v-model.trim="volunteer.nrc_no"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
          <v-col cols="12" lg="4" sm="12">
          <label>Father Name</label>
          <v-text-field
            v-model.trim="volunteer.father_name"
            type="text"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" lg="3">
          <label>Gender <require-sign /></label>
          <v-radio-group
            :error-messages="handleFieldErrors($v.volunteer.gender)"
            v-model="volunteer.gender"
            row
          >
            <v-radio label="Male" value="1"></v-radio>
            <v-radio label="Female" value="2"></v-radio>
            <v-divider vertical></v-divider>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="12" lg="4">
          <label>Education Status <require-sign /></label>
          <v-radio-group
            :error-messages="handleFieldErrors($v.volunteer.education_status)"
            v-model="volunteer.education_status"
            row
          >
            <v-radio label="Higher" value="1"></v-radio>
            <v-radio label="Primary" value="2"></v-radio>
            <v-radio label="Secondary" value="3"></v-radio>
            <v-divider vertical></v-divider>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="12" lg="4">
          <label>Occupation <require-sign /></label>
          <v-radio-group
            :error-messages="handleFieldErrors($v.volunteer.occupation)"
            v-model="volunteer.occupation"
            row
          >
            <v-radio label="AMW" value="1"></v-radio>
            <v-radio label="CHW" value="2"></v-radio>
            <v-radio label="Other" value="3"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <label>Remark</label>
      <v-textarea
        rows="3"
        placeholder="remark..."
        v-model.trim="volunteer.remark"
        outlined
        dense
      ></v-textarea>
    </v-card-text>

    <v-card-actions class="px-4 pb-4">
      <v-spacer></v-spacer>
      <v-btn v-if="volunteer.id" @click.prevent="emitData" class="form-btn">
        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
      </v-btn>
      <v-btn v-else @click.prevent="emitData" class="form-btn">
        <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import { ValidationMixin } from "./../../mixins/ValidationMixin";
import { mapState } from "vuex";
import FormRequireNoti from "@/components/notification/FormRequireNoti";
import RequireSign from "@/components/notification/RequireSign";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { FormRequireNoti, RequireSign, DatePicker },
  mixins: [ValidationMixin],
  props: {
    volunteer: {
      type: Object,
      default: () => {
        return {
          name: null,
          address: null,
          phone: null,
          phone2: null,
          age: null,
          remark: null,
          gender: null,
          education_status: null,
          occupation: null,
          both_mdr_picts: 1,
          joining_date: null,
          nrc_no: null,
          father_name: null,
        };
      },
    },
  },
  data: () => ({}),
  validations: {
    volunteer: {
      name: {
        required,
      },
      address: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9),
      },
      phone2: {
        minLength: minLength(9),
      },
      age: {
        required,
        between: between(5, 120),
      },
      gender: {
        required,
      },
      education_status: {
        required,
      },
      occupation: {
        required,
      },
    },
  },
  computed: {
    ...mapState("Loading", ["loading"]),
    ...mapState("Admin", ["admin"]),
  },
  methods: {
    emitData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let data = {
          name: this.volunteer.name,
          phone: this.volunteer.phone,
          phone2: this.volunteer.phone2,
          address: this.volunteer.address,
          gender: this.volunteer.gender,
          education_status: this.volunteer.education_status,
          occupation: this.volunteer.occupation,
          remark: this.volunteer.remark,
          age: this.volunteer.age,
          both_mdr_picts: this.volunteer.both_mdr_picts,
          joining_date: this.volunteer.joining_date,
          nrc_no: this.volunteer.nrc_no,
          father_name: this.volunteer.father_name,
        };

        this.volunteer.id ? (data.id = this.volunteer.id) : false;

        this.$emit("emitData", data);

        this.volunteer.name = null;
        this.volunteer.address = null;
        this.volunteer.age = null;
        this.volunteer.gender = null;
        this.volunteer.phone = null;
        this.volunteer.phone2 = null;
        this.volunteer.remark = null;
        this.volunteer.education_status = null;
        this.volunteer.occupation = null;
        this.volunteer.joining_date = null;
        this.volunteer.nrc_no = null;
        this.volunteer.father_name = null;
        this.volunteer.both_mdr_picts = 1;

        this.$v.$reset();
      }
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
